<div class="dialog">
  <div class="dialog-header">
    <h4 mat-dialog-title>
      <mat-icon>precision_manufacturing</mat-icon>
      {{ data.id ? ('tunneling_title_edit' | translate) : ('tunneling_title_add' | translate) }}
    </h4>
    <button type="button" class="close-button" (click)="onNoClick()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <form #form="ngForm">
    <div class="custom-tabs-container">
      <div class="custom-tabs main-tabs-custom">
        <button type="button" class="custom-tab" [class.active]="activeTab === 0" (click)="activeTab = 0">
          <mat-icon>info</mat-icon>
          <span>{{ 'tunneling_tab_info' | translate }}</span>
        </button>
        <button type="button" class="custom-tab" [class.active]="activeTab === 1" (click)="activeTab = 1">
          <mat-icon>precision_manufacturing</mat-icon>
          <span>{{ 'common_field_tunneling' | translate }}</span>
        </button>
        <button type="button" class="custom-tab" [class.active]="activeTab === 2" (click)="activeTab = 2">
          <mat-icon>eco</mat-icon>
          <span>{{ 'tunneling_tab_logistics' | translate }}</span>
        </button>
        <div class="tab-indicator" [style.transform]="'translateX(' + activeTab * 100 + '%)'"></div>
      </div>
    </div>

    <div class="tab-panels">
      <div class="tab-panel" *ngIf="activeTab === 0">
        <div class="tab-content">
          <div class="form-row">
            <div class="form-field flex-1">
              <div class="label-with-tooltip">
                <label class="form-label">{{ 'tunneling_label_name' | translate }}</label>
              </div>
              <input type="text" class="form-input" [placeholder]="'tunneling_placeholder_name' | translate" [(ngModel)]="data.displayName" name="displayName" required cdkFocusInitial />
            </div>

            <div class="form-field flex-1">
              <div class="label-with-tooltip">
                <label class="form-label">{{ 'tunneling_label_presence_days' | translate }}</label>
                <mat-icon [matTooltip]="'tunneling_tooltip_presence_days' | translate" matTooltipClass="tool-tip">help_outline</mat-icon>
              </div>
              <input type="number" class="form-input" [placeholder]="'tunneling_placeholder_presence_days' | translate" [(ngModel)]="data.presenceDuration" name="presenceDuration" min="0" required />
            </div>
          </div>

          <div class="form-row">
            <div class="form-field flex-1">
              <label class="form-label">{{ 'tunneling_label_network_days' | translate }}</label>
              <input type="number" class="form-input" [placeholder]="'tunneling_placeholder_network_days' | translate" [(ngModel)]="data.networkDuration" name="networkDuration" min="0" required />
            </div>

            <div class="form-field flex-1">
              <label class="form-label">{{ 'tunneling_label_generator_days' | translate }}</label>
              <input type="number" class="form-input" [placeholder]="'tunneling_placeholder_generator_days' | translate" [(ngModel)]="data.generatorDuration" name="generatorDuration" min="0" />
            </div>
          </div>

          <div class="alert alert-warning" *ngIf="data.presenceDuration && data.presenceDuration > 0 && !joursValides">
            <mat-icon>error_outline</mat-icon>
            <span>{{ 'tunneling_warning_days_mismatch' | translate: { presenceDuration: data.presenceDuration, currentTotal: (data.networkDuration || 0) + (data.generatorDuration || 0) } }}</span>
          </div>

          <div class="form-field">
            <label class="form-label">{{ 'tunneling_label_generator_operation' | translate }}</label>
            <div *ngIf="isLoadingVehicleEnergies" class="skeleton skeleton-input" role="status" aria-busy="true"></div>
            <mat-select *ngIf="!isLoadingVehicleEnergies" class="fuel-select" [ngModel]="data.selectedFuel" name="selectedFuel" (selectionChange)="onFuelChange($event.value)" [placeholder]="'tunneling_placeholder_generator_operation' | translate">
              <mat-option *ngFor="let energy of vehicleEnergies" [value]="energy.resourceId">{{ energy.displayName }}</mat-option>
            </mat-select>
          </div>
        </div>
      </div>

      <div class="tab-panel" *ngIf="activeTab === 1">
        <div class="tab-content">
          <div class="custom-tabs sub-tabs-custom">
            <button type="button" class="custom-sub-tab" [class.active]="tunnelierSubTab === 0" (click)="tunnelierSubTab = 0">
              <mat-icon>factory</mat-icon>
              <span>{{ 'tunneling_subtab_fabrication' | translate }}</span>
            </button>
            <button type="button" class="custom-sub-tab" [class.active]="tunnelierSubTab === 1" (click)="tunnelierSubTab = 1">
              <mat-icon>place</mat-icon>
              <span>{{ 'tunneling_subtab_transfer' | translate }}</span>
            </button>
            <button type="button" class="custom-sub-tab" [class.active]="tunnelierSubTab === 2" (click)="tunnelierSubTab = 2">
              <mat-icon>bolt</mat-icon>
              <span>{{ 'tunneling_subtab_usage' | translate }}</span>
            </button>
          </div>

          <div class="sub-tab-panels">
            <div class="sub-tab-panel" *ngIf="tunnelierSubTab === 0">
              <div class="sub-tab-content">
                <mat-expansion-panel [(expanded)]="openCommentFabrication" class="comment-panel">
                  <mat-expansion-panel-header>
                    <mat-panel-title class="comment-title">{{ 'tunneling_label_comment' | translate }}</mat-panel-title>
                  </mat-expansion-panel-header>
                  <div class="form-field">
                    <textarea class="form-textarea" [placeholder]="'tunneling_placeholder_comment' | translate" [(ngModel)]="data.buildComment" name="buildComment" rows="2"></textarea>
                  </div>
                </mat-expansion-panel>

                <div class="form-row">
                  <div class="form-field flex-1">
                    <div class="label-with-tooltip">
                      <label class="form-label">{{ 'tunneling_label_type' | translate }}</label>
                      <mat-icon [matTooltip]="'tunneling_tooltip_type' | translate" matTooltipClass="tool-tip">help_outline</mat-icon>
                    </div>
                    <mat-radio-group [(ngModel)]="data.equipementState" name="equipementState" class="radio-group-horizontal" (ngModelChange)="updateFacteurEmissionLabel()">
                      <mat-radio-button *ngFor="let type of TYPES_TUNNELIER" [value]="type.value">{{ type.label }}</mat-radio-button>
                    </mat-radio-group>
                  </div>

                  <div class="form-field flex-1">
                    <label class="form-label">{{ 'tunneling_label_mass' | translate }}</label>
                    <input type="number" class="form-input" [placeholder]="'tunneling_placeholder_mass' | translate" [(ngModel)]="data.grosWeight" name="grosWeight" min="0" step="0.1" required />
                  </div>
                </div>

                <div class="emissions-card blue">
                  <div class="emissions-header">
                    <mat-icon>factory</mat-icon>
                    <span>{{ 'tunneling_impact_fabrication' | translate }}</span>
                    <span class="fe-label" *ngIf="!isLoadingTunnelingEnvData">({{ facteurEmissionLabel }})</span>
                    <span class="skeleton skeleton-label" role="status" aria-busy="true" *ngIf="isLoadingTunnelingEnvData"></span>
                  </div>
                  <div class="emissions-values">
                    <div class="emission-item">
                      <span class="emission-label">{{ 'tunneling_per_day' | translate }}</span>
                      <span class="emission-value" *ngIf="!isLoadingTunnelingEnvData">{{ fabricationJour | localizedNumber: '1.4-4' }} <span class="unit">tCO2eq</span></span>
                      <span class="skeleton skeleton-value" role="status" aria-busy="true" *ngIf="isLoadingTunnelingEnvData"></span>
                    </div>
                    <div class="emission-item">
                      <span class="emission-label">{{ 'tunneling_total' | translate }}</span>
                      <span class="emission-value" *ngIf="!isLoadingTunnelingEnvData">{{ fabricationTotal | localizedNumber: '1.4-4' }} <span class="unit">tCO2eq</span></span>
                      <span class="skeleton skeleton-value" role="status" aria-busy="true" *ngIf="isLoadingTunnelingEnvData"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="sub-tab-panel" *ngIf="tunnelierSubTab === 1">
              <div class="sub-tab-content">
                <mat-expansion-panel [(expanded)]="openCommentTransfert" class="comment-panel">
                  <mat-expansion-panel-header>
                    <mat-panel-title class="comment-title">{{ 'tunneling_label_comment' | translate }}</mat-panel-title>
                  </mat-expansion-panel-header>
                  <div class="form-field">
                    <textarea class="form-textarea" [placeholder]="'tunneling_placeholder_comment' | translate" [(ngModel)]="data.transportationComment" name="transportationComment" rows="2"></textarea>
                  </div>
                </mat-expansion-panel>

                <div class="form-row">
                  <div class="form-field flex-1">
                    <div class="label-with-tooltip">
                      <label class="form-label">{{ 'tunneling_label_transfer_distance' | translate }}</label>
                      <a href="https://www.google.com/maps" target="_blank" rel="noopener noreferrer" class="maps-link">
                        <mat-icon>place</mat-icon>
                        Google Maps
                        <mat-icon>open_in_new</mat-icon>
                      </a>
                    </div>
                    <input type="number" class="form-input" [placeholder]="'tunneling_placeholder_transfer_distance' | translate" [(ngModel)]="data.transportationDistance" name="transportationDistance" min="0" step="1" required />
                  </div>
                </div>

                <div class="emissions-card amber">
                  <div class="emissions-header">
                    <mat-icon>place</mat-icon>
                    <span>{{ 'tunneling_impact_transfer' | translate }}</span>
                    <span class="fe-label" *ngIf="!isLoadingTunnelingEnvData">({{ tunnelingEnvData?.transferFactor ?? 0 }} tCO2/t.km)</span>
                    <span class="skeleton skeleton-label" role="status" aria-busy="true" *ngIf="isLoadingTunnelingEnvData"></span>
                  </div>
                  <div class="emissions-values">
                    <div class="emission-item">
                      <span class="emission-label">{{ 'tunneling_per_day' | translate }}</span>
                      <span class="emission-value" *ngIf="!isLoadingTunnelingEnvData">{{ transfertJour | localizedNumber: '1.4-4' }} <span class="unit">tCO2eq</span></span>
                      <span class="skeleton skeleton-value" role="status" aria-busy="true" *ngIf="isLoadingTunnelingEnvData"></span>
                    </div>
                    <div class="emission-item">
                      <span class="emission-label">{{ 'tunneling_total' | translate }}</span>
                      <span class="emission-value" *ngIf="!isLoadingTunnelingEnvData">{{ transfertTotal | localizedNumber: '1.4-4' }} <span class="unit">tCO2eq</span></span>
                      <span class="skeleton skeleton-value" role="status" aria-busy="true" *ngIf="isLoadingTunnelingEnvData"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="sub-tab-panel" *ngIf="tunnelierSubTab === 2">
              <div class="sub-tab-content">
                <mat-expansion-panel [(expanded)]="openCommentUtilisation" class="comment-panel">
                  <mat-expansion-panel-header>
                    <mat-panel-title class="comment-title">{{ 'tunneling_label_comment' | translate }}</mat-panel-title>
                  </mat-expansion-panel-header>
                  <div class="form-field">
                    <textarea class="form-textarea" [placeholder]="'tunneling_placeholder_comment' | translate" [(ngModel)]="data.usagePhaseComment" name="usagePhaseComment" rows="2"></textarea>
                  </div>
                </mat-expansion-panel>

                <div class="form-row">
                  <div class="form-field flex-1">
                    <label class="form-label">{{ 'tunneling_label_power' | translate }}</label>
                    <input type="number" class="form-input" [placeholder]="'tunneling_placeholder_power' | translate" [(ngModel)]="data.equipementPower" name="equipementPower" min="0" step="1" required />
                  </div>

                  <div class="form-field flex-1">
                    <label class="form-label">{{ 'tunneling_label_consumed_power' | translate }}</label>
                    <div class="computed-value">{{ puissanceConsommeeTunnelier | localizedNumber: '1.0-0' }}</div>
                  </div>
                </div>

                <div class="emissions-card green">
                  <div class="emissions-header">
                    <mat-icon>bolt</mat-icon>
                    <span>{{ 'tunneling_impact_usage' | translate }}</span>
                    <span class="fe-label">({{ 'tunneling_impact_usage_note' | translate }})</span>
                  </div>
                  <div class="emissions-values">
                    <div class="emission-item">
                      <span class="emission-label">{{ 'tunneling_per_day' | translate }}</span>
                      <span class="emission-value" *ngIf="!isLoadingEnvData">{{ utilisationJour | localizedNumber: '1.4-4' }} <span class="unit">tCO2eq</span></span>
                      <span class="skeleton skeleton-value" role="status" aria-busy="true" *ngIf="isLoadingEnvData"></span>
                    </div>
                    <div class="emission-item">
                      <span class="emission-label">{{ 'tunneling_total' | translate }}</span>
                      <span class="emission-value" *ngIf="!isLoadingEnvData">{{ utilisationTotal | localizedNumber: '1.4-4' }} <span class="unit">tCO2eq</span></span>
                      <span class="skeleton skeleton-value" role="status" aria-busy="true" *ngIf="isLoadingEnvData"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="total-tunnelier-card">
            <div class="total-header">
              <mat-icon>precision_manufacturing</mat-icon>
              <span>{{ 'tunneling_total_tunnelier' | translate }}</span>
            </div>
            <div class="total-values">
              <div class="total-item">
                <span class="total-label">{{ 'tunneling_per_day' | translate }}</span>
                <span class="total-value" *ngIf="!isLoadingEnvData">{{ totalTunnelierJour | localizedNumber: '1.4-4' }} <span class="unit">tCO2eq</span></span>
                <span class="skeleton skeleton-value" role="status" aria-busy="true" *ngIf="isLoadingEnvData"></span>
              </div>
              <div class="total-item">
                <span class="total-label">{{ 'tunneling_total' | translate }}</span>
                <span class="total-value" *ngIf="!isLoadingEnvData">{{ totalTunnelierTotal | localizedNumber: '1.4-4' }} <span class="unit">tCO2eq</span></span>
                <span class="skeleton skeleton-value" role="status" aria-busy="true" *ngIf="isLoadingEnvData"></span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="tab-panel" *ngIf="activeTab === 2">
        <div class="tab-content">
          <mat-expansion-panel [(expanded)]="openCommentSuiteLogistique" class="comment-panel">
            <mat-expansion-panel-header>
              <mat-panel-title class="comment-title">{{ 'tunneling_label_comment' | translate }}</mat-panel-title>
            </mat-expansion-panel-header>
            <div class="form-field">
              <textarea class="form-textarea" [placeholder]="'tunneling_placeholder_comment' | translate" [(ngModel)]="data.equipementSuportComment" name="equipementSuportComment" rows="2"></textarea>
            </div>
          </mat-expansion-panel>

          <div class="form-row three-cols">
            <div class="form-field">
              <label class="form-label">{{ 'tunneling_logistics_label_mass' | translate }}</label>
              <input type="number" class="form-input" [placeholder]="'tunneling_logistics_placeholder_mass' | translate" [(ngModel)]="data.equipementSuportMass" name="equipementSuportMass" min="0" step="0.1" />
            </div>

            <div class="form-field">
              <label class="form-label">{{ 'tunneling_logistics_label_power' | translate }}</label>
              <input type="number" class="form-input" [placeholder]="'tunneling_logistics_placeholder_power' | translate" [(ngModel)]="data.equipementSuportPower" name="equipementSuportPower" min="0" step="1" />
            </div>

            <div class="form-field">
              <label class="form-label">{{ 'tunneling_logistics_label_consumed_power' | translate }}</label>
              <div class="computed-value">{{ puissanceConsommeeSuite | localizedNumber: '1.0-0' }}</div>
            </div>
          </div>

          <div class="emissions-card-full purple">
            <div class="emissions-header-full">
              <div class="icon-circle">
                <mat-icon>inventory_2</mat-icon>
              </div>
              <span>{{ 'tunneling_logistics_impact_title' | translate }}</span>
            </div>
            <div class="emissions-grid">
              <div class="emission-box">
                <span class="emission-label">{{ 'tunneling_per_day' | translate }}</span>
                <span class="emission-value" *ngIf="!isLoadingEnvData">{{ suiteLogistiqueJour | localizedNumber: '1.6-6' }} <span class="unit">tCO2eq</span></span>
                <span class="skeleton skeleton-value" role="status" aria-busy="true" *ngIf="isLoadingEnvData"></span>
              </div>
              <div class="emission-box">
                <span class="emission-label">{{ 'tunneling_total' | translate }}</span>
                <span class="emission-value" *ngIf="!isLoadingEnvData">{{ suiteLogistiqueTotal | localizedNumber: '1.6-6' }} <span class="unit">tCO2eq</span></span>
                <span class="skeleton skeleton-value" role="status" aria-busy="true" *ngIf="isLoadingEnvData"></span>
              </div>
            </div>
            <p class="emission-note">{{ 'tunneling_logistics_impact_note' | translate }}</p>
          </div>

          <div class="equipements-section">
            <div class="label-with-tooltip">
              <label class="form-label">{{ 'tunneling_logistics_select_equipment' | translate }}</label>
              <mat-icon [matTooltip]="'tunneling_logistics_tooltip_equipment' | translate" matTooltipClass="tool-tip">help_outline</mat-icon>
            </div>
            <div class="equipements-grid">
              <div class="equipement-item" *ngFor="let equip of EQUIPEMENTS_SUITE_LOGISTIQUE">
                <mat-checkbox [checked]="isEquipementSelected(equip.id)" (change)="toggleEquipement(equip.id)">
                  {{ equip.label }}
                </mat-checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="total-global-section">
      <div class="total-global-header">
        <div class="icon-circle">
          <mat-icon>eco</mat-icon>
        </div>
        <h3>{{ 'tunneling_total_impact_title' | translate }}</h3>
      </div>
      <div class="total-global-grid">
        <div class="total-global-item">
          <span class="total-global-label">{{ 'tunneling_daily_emissions' | translate }}</span>
          <span class="total-global-value" *ngIf="!isLoadingEnvData">{{ totalGlobalJour | localizedNumber: '1.2-2' }} <span class="unit">tCO2eq/jour</span></span>
          <span class="skeleton skeleton-value-lg" role="status" aria-busy="true" *ngIf="isLoadingEnvData"></span>
        </div>
        <div class="total-global-item">
          <span class="total-global-label">{{ 'tunneling_total_emissions' | translate }}</span>
          <span class="total-global-value" *ngIf="!isLoadingEnvData">{{ totalGlobalTotal | localizedNumber: '1.2-2' }} <span class="unit">tCO2eq</span></span>
          <span class="skeleton skeleton-value-lg" role="status" aria-busy="true" *ngIf="isLoadingEnvData"></span>
        </div>
      </div>
    </div>

    <div class="upload-section">
      <input type="file" #fileInput (change)="onFileSelected($event)" style="display: none" accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png" />
      <label class="upload-btn" (click)="fileInput.click()">
        <mat-icon>upload</mat-icon>
        <span>{{ 'tunneling_add_justificatif' | translate }}</span>
      </label>

      <div class="justificatifs-list" *ngIf="data.fileName">
        <div class="file-chip">
          <mat-icon>description</mat-icon>
          <span>{{ data.fileName }}</span>
          <button type="button" (click)="removeJustificatif()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <div class="alert alert-info" *ngIf="!isFormValid()">
      <mat-icon>warning_amber</mat-icon>
      <span>{{ 'tunneling_validation_warning' | translate }}</span>
    </div>
  </form>

  <div mat-dialog-actions>
    <button type="button" mat-button (click)="onNoClick()" [disabled]="saving">
      <mat-icon>close</mat-icon>
      {{ 'tunneling_btn_cancel' | translate }}
    </button>
    <button mat-flat-button (click)="onSave()" color="accent" [disabled]="!isFormValid() || saving">
      <mat-icon>{{ data.id ? 'save' : 'add' }}</mat-icon>
      {{ saving ? ('tunneling_btn_saving' | translate) : ('tunneling_btn_save' | translate) }}
    </button>
  </div>
</div>
